import { createReducer } from "../../../utils/create-reducer";
import { S3 } from "../../../utils/action-names.json";

const s3 = createReducer(S3);

export default s3;
